export const odooConfiguration = {
  odoo_configurations: `Odoo configurations`,
  odoo_invoicedate_missing: "Invoice date is required.",
  odoo_invoiceduedate_missing: "Invoice due date is required.",
  odoo_odoovendorid_missing: "Vendor ID is required.",
  odoo_odooaccountjournalid_missing: "Account journal ID is required.",
  odoo_odoocurrencyid_missing: "Currency ID is required.",
  odoo_articles_required: "At least one article is required.",
  odoo_articles_quantity_required: "Article quantity is required.",
  odoo_articles_unitprice_required: "Article unit price is required.",
  odoo_article_either_itemid_or_acctid_required:
    "Each article must have either an item ID or an account ID.",
  odoo_items_required: "At least one item is required.",
  odoo_item_quantity_missing: "Item quantity is required.",
  odoo_item_unitprice_missing: "Item unit price is required.",
  odoo_item_either_itemid_or_acctid_required:
    "Each item must have either an item ID or an account ID.",
};
